import * as React from 'react';
import {SyntheticEvent} from 'react';
import { Button, Loader } from '@mantine/core';
import IconButton from '../IconButton/IconButton';

type ButtonType = 'button' | 'submit' | 'reset';

interface LoadingButtonProps {
  loading: boolean;
  label: string;
  className?: string;
  type?: ButtonType;
  // Legacy bootstrap variant string; we still accept and map it.
  variant?: string;
  // Legacy direct color override (hex/rgb). If provided, we honor it via inline styles.
  color?: string;
  disabled?: boolean;
  onClick?: (e: SyntheticEvent<HTMLButtonElement>) => void;
  iconButtons?: boolean;
}

function mapBootstrapToMantine(variant?: string): { color?: string; variant?: 'filled' | 'light' | 'outline' | 'subtle' | 'default' } {
  switch ((variant || '').toLowerCase()) {
    case 'primary':
      return { color: 'indigo', variant: 'filled' };
    case 'success':
      return { color: 'green', variant: 'filled' };
    case 'danger':
      return { color: 'red', variant: 'filled' };
    case 'warning':
      return { color: 'yellow', variant: 'filled' };
    case 'info':
      return { color: 'blue', variant: 'light' };
    case 'secondary':
      return { color: 'gray', variant: 'light' };
    case 'light':
      return { color: 'gray', variant: 'light' };
    case 'dark':
      return { color: 'dark', variant: 'filled' };
    case 'link':
      return { color: 'indigo', variant: 'subtle' };
    default:
      return { color: 'indigo', variant: 'filled' };
  }
}

export const LoadingButton = ({variant, onClick, className, disabled, label, loading, type, color, iconButtons = false}: LoadingButtonProps) => {
  const mapped = mapBootstrapToMantine(variant);
  const inlineStyle = color && !/^([a-z]+)$/i.test(color) ? { backgroundColor: color, color: 'white' } : undefined;
  const resolvedColor = color && /^([a-z]+)$/i.test(color) ? color : mapped.color;
  const resolvedVariant = mapped.variant;

  if (!iconButtons) {
    return (
      <Button loading={loading} disabled={loading || disabled} variant={resolvedVariant} color={resolvedColor} type={type || 'button'}
              className={className} onClick={onClick} style={inlineStyle}>
        {label}
      </Button>
    );
  } else {
    return (
      <>
        {loading ? (
          <Loader size="sm" />
        ) : (
          <>
            <Button disabled={disabled} variant={resolvedVariant} color={resolvedColor} type={type || 'button'} className={className} onClick={onClick}>
              <IconButton
                icon={label === 'Edit' ? 'pen' : 'check'}
                color={'#005A9C'}
                customSize={label !== 'Edit' ? 20 : undefined}
              />
            </Button>
          </>
        )}
      </>
    );
  }
};
